/* ── Reusable timeline navigation indicators ─────────────── */

interface IndicatorProps {
  active?: boolean;
  color?: string;
  bgColor?: string;
}

/** Circle indicator - use for parent / group-level nav items */
export function CircleIndicator({
  active = false,
  color = "#388BFD",
  bgColor = "#0D1322",
}: IndicatorProps) {
  return (
    <span className="relative z-10 flex-shrink-0 flex items-center justify-center size-[14px]">
      <span
        className="rounded-full transition-all duration-200"
        style={{
          width: active ? 10 : 8,
          height: active ? 10 : 8,
          border: `2px solid ${active ? color : "rgba(255,255,255,0.25)"}`,
          backgroundColor: active ? color : bgColor,
        }}
      />
    </span>
  );
}


/** Diamond (rotated square) indicator - use for child / sub-item nav */
export function DiamondIndicator({
  active = false,
  color = "#388BFD",
  bgColor = "#0D1322",
}: IndicatorProps) {
  return (
    <span className="relative z-10 flex-shrink-0 flex items-center justify-center size-[14px]">
      <span
        className="transition-all duration-200"
        style={{
          width: 6,
          height: 6,
          transform: "rotate(45deg)",
          border: `1.5px solid ${active ? color : "rgba(255,255,255,0.25)"}`,
          backgroundColor: bgColor,
          borderRadius: 1,
        }}
      />
    </span>
  );
}

/** Vertical connecting line for timeline navigation */
export function TimelineLine({
  color = "rgba(255,255,255,0.08)",
  centerX = 23,
  top = 14,
  bottom = 14,
}: {
  color?: string;
  centerX?: number;
  top?: number;
  bottom?: number;
}) {
  return (
    <div
      className="absolute z-0 pointer-events-none"
      style={{
        left: centerX,
        top,
        bottom,
        width: 1.5,
        transform: "translateX(-50%)",
        backgroundColor: color,
      }}
    />
  );
}
